document.addEventListener('DOMContentLoaded', function () {
 
    const dateElement = document.getElementById('m-date');
    if (dateElement) {
        const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
        ];

        const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
        ];

        const getDate = (daysToAdd) => {
        const date = new Date();
        date.setDate(date.getDate() + daysToAdd);

        return `${days[date.getDay()]} ${String(date.getDate()).padStart(2, '0')} ${months[date.getMonth()]}`;
        };

        dateElement.innerHTML =
        `Estimated delivery between <strong>${getDate(6)}</strong> to <strong>${getDate(9)}</strong>`;
    }


    document.addEventListener('click', function (event) {
      const rating = event.target.closest('.pdp_star_rating_container');
      if (!rating) return;
      const reviewSection = document.querySelector('[id*="__google_reviewe_"]');
      if (reviewSection) {
      reviewSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});